export const setAttributes = (key: string, value: string) => {
  document.documentElement.setAttribute(key, value);
};

export const setSiteFontFamilyByTheme = (layoutTheme: string) => {
  const fontLink = document.getElementById("fontsLink");

  if (fontLink) {
    switch (layoutTheme) {
      default:
        fontLink.setAttribute(
          "href",
          "https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
        );
        break;
    }
  }
};
